// migrated 2026-04-27 to SDK route workspaceProject.documents.kb
import { getSDK } from '../../../shared/functions/sdk.js'

// kb_articles.content is EditorJS JSONB — wrap plain text into a single
// paragraph block before insert.
const _toEditorBlocks = (text) => ({
  time: Date.now(),
  blocks: text
    ? [{ id: Math.random().toString(36).slice(2, 12), type: 'paragraph', data: { text } }]
    : [],
  version: '2.31.6'
})

export const createKnowledgeArticle = async function ({ title = 'Untitled article', content = '' } = {}) {
  const root = this.state.root
  const row = {
    title,
    content: _toEditorBlocks(content),
    author: root.currentUserEmail || 'Unknown',
    // Populate `author_email` for Phase E ownership-gated RLS (0069).
    author_email: root.currentUserEmail || null
  }
  let data
  try {
    const result = await getSDK().execute('workspaceProject.documents.kb', 'create', { payload: row })
    data = result?.data || result
  } catch (err) {
    console.error('[createKnowledgeArticle] insert failed', err)
    return null
  }
  if (!data?.id) return null
  root.update({
    kbArticles: [...(root.kbArticles || []), { id: data.id, ...row, createdAt: new Date().toISOString().slice(0, 10) }],
    selectedKbArticleId: data.id
  })
  return data.id
}
